var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ba25d10ec587c57fcfbc9630a0dac9a78f30e760"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fontvisual"]={id:"ba25d10ec587c57fcfbc9630a0dac9a78f30e760"};
      